// Badge compacto de nível do cliente
// Uso: <NivelBadge nivel="ouro" /> ou <NivelBadge nivel="platinum" size="sm" />
const NIVEIS_EMOJI = {
  bronze: { emoji: "🥉", label: "Bronze" },
  prata: { emoji: "🥈", label: "Prata" },
  ouro: { emoji: "🥇", label: "Ouro" },
  platinum: { emoji: "⭐", label: "Platinum" },
  diamante: { emoji: "💎", label: "Diamante" },
};

export default function NivelBadge({ nivel, size = "xs", showLabel = false, className = "" }) {
  const n = NIVEIS_EMOJI[nivel] || NIVEIS_EMOJI.bronze;
  const sz = size === "sm" ? "text-sm" : size === "md" ? "text-base" : "text-xs";
  return (
    <span
      className={`inline-flex items-center gap-0.5 ${sz} ${className}`}
      title={`Nível ${n.label}`}
      data-testid={`nivel-${nivel}`}
    >
      <span aria-hidden>{n.emoji}</span>
      {showLabel && <span className="text-[10px] font-medium text-gray-600">{n.label}</span>}
    </span>
  );
}
